import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericApiResponse } from '../models/api-response.model';
import { SimpleCodeValue } from '../models/code-value.model';
import {
    EmployeeSearchRequest,
    EmployeeSearchResponse,
    EmployeeSaveRequest,
    EndEmployeeRequest
} from '../models/employee.model';

@Injectable({
    providedIn: 'root'
})
export class EmployeeService {

    constructor(private http: HttpClient) { }

    searchEmployees(request: EmployeeSearchRequest): Observable<EmployeeSearchResponse> {
        return this.http.post<EmployeeSearchResponse>('/employee/v1/search', request);
    }

    saveEmployee(request: EmployeeSaveRequest): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>('/employee/v1/save', request);
    }

    updateEmployee(request: EmployeeSaveRequest): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>('/employee/v1/update', request);
    }

    endEmployee(request: EndEmployeeRequest): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>('/employee/v1/endEmployee', request);
    }

    getLonavalaAreaOptions(): Observable<SimpleCodeValue[]> {
        return this.http.get<SimpleCodeValue[]>('/employee/v1/lonavala-area-options');
    }

    getEmployeeAreaAccess(employeeId: number): Observable<number[]> {
        return this.http.get<number[]>(`/employee/v1/${employeeId}/area-access`);
    }
}
